// @ts-strict-ignore
import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';

const VersionCheckContainer: React.FC = () => {
    const [showVersionUpdateAlert, setShowVersionUpdateAlert] = React.useState(false);
    const version = useSelector((state: RootState) => state.appConfig?.version);

    // reload the page if the version has changed
    React.useEffect(() => {
        if (version && version !== PACKAGE_VERSION) {
            setShowVersionUpdateAlert(true);
        }
    }, [version]);

    const reloadPage = () => {
        location.reload();
    };

    return (
        showVersionUpdateAlert && (
            <Alert
                banner
                message="Your version of Runway is out of date. Reload the page to get the latest version."
                type="warning"
                showIcon
                action={
                    <Button size="small" type="primary" onClick={reloadPage}>
                        Reload
                    </Button>
                }
                closable
            />
        )
    );
};

export default VersionCheckContainer;
